import React from 'react';
import { whatsappLink } from '../data/mock';
import { WhatsAppIcon } from './WhatsAppIcon';

const WhatsAppButton = () => (
  <a
    href={whatsappLink()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Fale conosco pelo WhatsApp"
    data-testid="whatsapp-button"
    className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-50 w-16 h-16 rounded-full bg-[#25D366] text-white shadow-[0_0_25px_rgba(37,211,102,0.5)] flex items-center justify-center transform hover:scale-110 transition-transform duration-300"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40"></span>
    <WhatsAppIcon className="w-8 h-8 relative" />
  </a>
);

export default WhatsAppButton;
